import { defineMessages } from 'react-intl';

import Edit from './Edit';
import View from './View';

import codeSVG from '@plone/volto/icons/code.svg';

defineMessages({
  legacyHTML: {
    id: 'Legacy HTML',
    defaultMessage: 'Legacy HTML',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.legacyHTML = {
    id: 'legacyHTML',
    title: 'Legacy HTML',
    icon: codeSVG,
    group: 'advanced',
    view: View,
    edit: Edit,
    // Bloco restrito a usuários com papel Manager
    restricted: ({ user }) => !user?.roles?.includes('Manager'),
    mostUsed: false,
    sidebarTab: 0,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
